export const cognitoPasswordPattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[_#$!|()=.,?*+-]).{1,1024}$';